import * as React from "react";
import PropTypes from 'prop-types';

const SvgArrowDown = props => {
  if (props.id !== "_svgarrowdown") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 17 24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M.267 16.005l6.698 7.038c.76.797 1.905.797 2.664 0l6.699-7.038c.329-.346.357-.94.063-1.328-.294-.387-.8-.421-1.13-.075L9.098 21.08V1.44c0-.519-.358-.94-.8-.94-.441 0-.8.421-.8.94v19.64l-6.165-6.477a.729.729 0 00-.532-.24.749.749 0 00-.596.314c-.294.388-.266.982.063 1.328z" fill="#202020" /></svg>;
};

SvgArrowDown.displayName = "_svgarrowdown";
SvgArrowDown.propTypes = {
  id: PropTypes.string
};
SvgArrowDown.defaultProps = {
  id: ''
};
export default SvgArrowDown;